import { defineMessages } from 'react-intl'

const scope = `procurify.components.AuthenticationRequiredPrompt`

export default defineMessages({
  headerText: {
    id: `${scope}.headerText`,
    defaultMessage: 'Authentication required',
  },
  message: {
    id: `${scope}.message`,
    defaultMessage:
      "For your security, you're required to verify your identity before viewing sensitive transaction details.",
  },
  startAuthButtonText: {
    id: `${scope}.startAuthButtonText`,
    defaultMessage: 'Start authentication',
  },
  historicalDataHeaderText: {
    id: `${scope}.historicalDataHeaderText`,
    defaultMessage: 'Verify your identity again',
  },
  historicalDataMessage: {
    id: `${scope}.historicalDataMessage`,
    defaultMessage:
      'Viewing transactions older than 90 days requires verifying your identity again.',
  },
  historicalDataButtonText: {
    id: `${scope}.historicalDataButtonText`,
    defaultMessage: 'Verify identity',
  },
})
